import { render, staticRenderFns } from "./EmployeeLayout.vue?vue&type=template&id=3c8fa9e6&scoped=true&"
import script from "./employeeLayout.js?vue&type=script&lang=js&"
export * from "./employeeLayout.js?vue&type=script&lang=js&"
import style0 from "./EmployeeLayout.vue?vue&type=style&index=0&id=3c8fa9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8fa9e6",
  null
  
)

export default component.exports